import React from "react";
import { useNavigate } from "react-router-dom";
import "../../products/productDetail.css";
import moment from "moment";

const PharmacyProductRequestTableData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();

  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data?.code ?? "--"}</td>
      <td className="table-each-row-data">
        {data?.pharmacy_name ? data?.pharmacy_name.toUpperCase() : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.pharmacyProductOffers?.length > 0
          ? data?.pharmacyProductOffers?.length
          : 0}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(
                `/customers/pharmacy-product-offer-request/view/${data?.id}`
              )
            }
          >
            {"view"}
          </button>
        </div>
      </td>
    </tr>
  );
};

export default PharmacyProductRequestTableData;

export const approvalStatus = [
  { status: "pending", value: "Pending", color: "Medium_Purple" },
  { status: "approved", value: "Approved", color: "text_green" },
  { status: "rejected", value: "Rejected", color: "text-danger" },
];
